// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useState } from 'react'
import './buttonOptionSelector.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { SecondaryButton } from 'ui_kit_qmd'
import classNames from 'classnames'
import downArrowIcon from '../../images/common/downArrowTeal.svg'
import upArrowIcon from '../../images/common/upArrowWhite.svg'
import checkIcon from '../../images/common/check.svg'
import { type ButtonOption } from '../../types/types'

interface Props {
  options: ButtonOption[]
  className: string
}
const arrowImageStyle = {
  height: 24,
  width: 24,
}
const mainContainerStyle = {
  width: 'auto',
  padding: '0px 8px',
  borderBottomRightRadius: 0,
  borderTopRightRadius: 0,
}
const dropdownContainerStyle = {
  width: 'auto',
  padding: '0px 8px',
  borderBottomLeftRadius: 0,
  borderTopLeftRadius: 0,
  borderLeftWidth: 0,
}
export const ButtonOptionsSelector = ({ options, className }: Props) => {
  const [showOptions, setShowOptions] = useState<boolean>(false)
  // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
  const [currentButton, setCurrentButton] = useState<ButtonOption>(options[0])
  function onClickListener() {
    // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
    setShowOptions((current) => {
      if (current) {
        return false
      }
    })
  }
  useEffect(() => {
    window.document.addEventListener('click', onClickListener)

    return () => {
      window.document.removeEventListener('click', onClickListener)
    }
  }, [])
  const onDropDownPress = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (e) => {
      if (!showOptions) {
        setShowOptions(true)
        e.stopPropagation()
      }
    },
    [showOptions],
  )
  return (
    <div className={classNames('button-options-selector-container', className)}>
      <div
        className={classNames('button-options-selector-button-container', {
          'is-options-showing': showOptions,
        })}>
        <SecondaryButton
          btnText={currentButton.buttonText}
          containerStyle={mainContainerStyle}
          imageStyle={currentButton.imageStyle}
          image={currentButton.image}
          onPress={currentButton.onPress}
        />
        <SecondaryButton
          containerStyle={dropdownContainerStyle}
          className='button-options-selector-drop-down-container'
          imageStyle={arrowImageStyle}
          image={showOptions ? upArrowIcon : downArrowIcon}
          onPress={onDropDownPress}
        />
      </div>
      {showOptions ? <div className='button-options-selector-option-list-container'>
          {options.map((option) => (
            <div
              role='presentation'
              className='button-options-selector-option-container'
              onClick={() => {
                setCurrentButton(option)
              }}
              key={option.buttonText}>
              <img
                className={classNames('button-options-selector-option-check-icon', {
                  hidden: currentButton.buttonText !== option.buttonText,
                })}
                src={checkIcon}
                alt={`${option.buttonText} selected`}
              />
              <div>{option.buttonText}</div>
            </div>
          ))}
        </div> : null}
    </div>
  )
}
